module.exports = __webpack_public_path__ + "img/qijian-jilu.ba56632a.svg";